import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppEnvironment } from '../config/app-environment';

@Injectable({
  providedIn: 'root',
})
export class ApiClientService {
  private readonly httpClient = inject(HttpClient);
  readonly baseUrl = AppEnvironment.apiBaseUrl;

  get<T>(path: string): Observable<T> {
    return this.httpClient.get<T>(`${this.baseUrl}${path}`);
  }

  post<TResponse, TRequest = unknown>(
    path: string,
    payload?: TRequest,
  ): Observable<TResponse> {
    return this.httpClient.post<TResponse>(`${this.baseUrl}${path}`, payload);
  }

  put<TResponse, TRequest = unknown>(
    path: string,
    payload?: TRequest,
  ): Observable<TResponse> {
    return this.httpClient.put<TResponse>(`${this.baseUrl}${path}`, payload);
  }

  delete<TResponse = void>(path: string): Observable<TResponse> {
    return this.httpClient.delete<TResponse>(`${this.baseUrl}${path}`);
  }

  getBlob(path: string): Observable<Blob> {
    return this.httpClient.get(`${this.baseUrl}${path}`, {
      responseType: 'blob',
    });
  }

  /** Like getBlob, but preserves response headers (e.g. Content-Disposition)
   * for callers that need the server-supplied filename. */
  getBlobResponse(path: string): Observable<HttpResponse<Blob>> {
    return this.httpClient.get(`${this.baseUrl}${path}`, {
      responseType: 'blob',
      observe: 'response',
    });
  }

  postFormData<T>(path: string, formData: FormData): Observable<T> {
    return this.httpClient.post<T>(`${this.baseUrl}${path}`, formData);
  }

  postFormDataForBlob(path: string, formData: FormData): Observable<Blob> {
    return this.httpClient.post(`${this.baseUrl}${path}`, formData, {
      responseType: 'blob',
    });
  }

  postForBlob(path: string): Observable<Blob> {
    return this.httpClient.post(`${this.baseUrl}${path}`, null, {
      responseType: 'blob',
    });
  }
}
